import React from "react";
import PlacementTableListing from "./placementTableListing";
import ImagesUrl from "#constants/images.js";
import { numberOnly } from "#utils/helpers.js";

const FertilityComponent = ({
  values,
  handleAddPlacement,
  handleAddProduct,
  handleBlur,
  handleChange,
  renderSoilTestInputs,
  parentIndex,
  handelRemoveProduct,
  handelRemovePlacement,
}) => {
  return (
    <div className="custom_accordion_item">
      {/* Accordion Toggle */}
      <button
        className="custom_accordion d-flex w-100 justify-content-between align-items-center border-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#collapseCrop_1${parentIndex}`}
        aria-expanded="false"
        aria-controls={`collapseCrop_1${parentIndex}`}
      >
        <p className="m-0 fertility_text">Fertility</p>
        <span className="drop_icon">
          <img className="drop_icon" src={ImagesUrl.dopeIcon} alt="drop-icon" />
        </span>
      </button>

      {/* Accordion Body */}
      <div
        className="custom_collapse_body collapse"
        id={`collapseCrop_1${parentIndex}`}
      >
        {/* Soil Test Section */}
        <div className="d-flex gap-4 align-items-center soil-test-warper">
          <p className="mb-0">Soil Test</p>
          <div className="inline_input">
            {["N", "P", "K", "S"]?.map((label, index) => (
              <input
                key={index}
                className="sol_input"
                placeholder={label}
                maxLength="2"
                name={`data[${parentIndex}].soilTest.${label}`}
                value={values?.data?.[parentIndex]?.soilTest?.[label] || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyPress={numberOnly}
              />
            ))}
          </div>
        </div>

        {/* Fertilizer Section */}
        <div className="d-flex align-items-center justify-content-between pt-4 px-5">
          <p className="fs-5 fw-medium mb-0">Fertilizer</p>
          <button
            className="report-btn2 primary-outline-btn-style"
            type="button"
            onClick={() => handleAddPlacement(parentIndex)}
          >
            + Add Placement
          </button>
        </div>

        {/* Placement Table Listing */}
        <div className="placement_card_wrapper">
          <PlacementTableListing
            handleAddProduct={handleAddProduct}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
            renderSoilTestInputs={renderSoilTestInputs}
            parentIndex={parentIndex}
            handelRemoveProduct={handelRemoveProduct}
            handelRemovePlacement={handelRemovePlacement}
          />
        </div>

        {/* Placement Summary */}
        <div className="placement_overall_info">
          <div className="placement_overall_item">
            <span>Total Fertilizer Nutrients</span>
            <span>
              {values?.data?.[parentIndex]?.totalFertilizerNutrients ||
                "0-0-0-0"}
            </span>
          </div>
          <div className="placement_overall_item">
            <span>Total Nutrients</span>
            <span>
              {values?.data?.[parentIndex]?.totalNutrients || "0-0-0-0"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FertilityComponent;
